import { useState } from "react";
import { AppButton, ConfirmationModal } from "@libs/zapi-ui/custom";

type CancelGenerationButtonProps = {
  onCancel: () => void;
  isCancelling: boolean;
};

export function CancelGenerationButton({ onCancel, isCancelling }: CancelGenerationButtonProps) {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  return (
    <>
      <AppButton size="default" color="zinc950" onClick={() => setIsConfirmOpen(true)} isLoading={isCancelling}>
        Cancel Generation
      </AppButton>
      <ConfirmationModal
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={onCancel}
        title="Cancel Generation"
        description="This will stop all chapter generation and revert the project version to Draft. Generated chapters will be deleted."
        confirmText="Cancel Generation"
        cancelText="Keep Generating"
      />
    </>
  );
}
